@if (costHitAllowed && costHitAllowed.allowed === false) {
  <p class="info-box smaller-text" translate [translateParams]="{ max: costHitAllowed.maxHits, hours: costHitAllowed.hours }">
    The maximum of ... cadastral information hits within ... hours has been reached.
  </p>
}